import Dexie from 'dexie';
import { useGenStore } from 'stores/useGenStore';

/**
 * Represents the database instance for PRISM_BUILDER.
 * @type {Dexie}
 */
export const db = new Dexie('PRISM_BUILDER');
db.version(2).stores({
  imageUpload: '++id, status, prismItemID, [status+prismItemID], createdAt', // [a+b] = compound index for where('[status+prismItemID]').equals([s, id])
  bulkOrder: '++id, productID, quantity, title, theme, prismItemID, order',
});
db.version(3).stores({
  imageUpload: '++id, status, prismItemID, [status+prismItemID], createdAt',
  bulkOrder: '++id, productID, quantity, title, theme, prismItemID, order',
  svgText: 'slotID', // slotID is the primary key (no ++): at most one record per slot; put() upserts
});

export const canUseIndexedDB = async (requiredSpace = 100 * 1024 * 1024) => {
  if (!('storage' in navigator) || !('estimate' in navigator.storage)) {
    return false;
  }

  const estimate = await navigator.storage.estimate();
  const availableSpace = estimate.quota - estimate.usage;

  return availableSpace > requiredSpace;
};

export const handleDexieError = (e, context = null) => {
  // Safari private mode blocks all IndexedDB writes with QuotaExceededError.
  // Tagging New Relic errors with safariPrivateMode lets us filter them from real quota alerts.
  const safariPrivateMode = useGenStore.getState().isSafariPrivate;

  if (typeof window.newrelic === 'object') {
    window.newrelic.noticeError(e, { safariPrivateMode, context });
  }

  switch (e.name) {
    case 'AbortError':
      console.error('Abort error ' + e.message, e?.inner);
      break;
    case 'QuotaExceededError':
      console.error('QuotaExceededError ' + e.message);
      break;
    default:
      console.error(e, context);
      break;
  }
};
